import React from 'react'
import styled from 'styled-components'
import colors from 'theme/colors'
import fonts from 'theme/fonts'

const SAMPLE_TEXT = {
    name: 'Maria',
    surname: 'Oliveira',
    name_surname: 'Maria Oliveira',
    surname_name: 'Oliveira Maria',
    ticket_type: 'Ingresso Inteira',
    ticket_code: 'AB12CD',
}

function renderLine(value) {
    if (!value || value === 'blank') return null
    if (value === 'barcode') return <PreviewBarcode key='barcode' />
    if (value === 'qrcode') return <PreviewQrCode key='qrcode' />

    return <PreviewText key={value}>{SAMPLE_TEXT[value]}</PreviewText>
}

export default function LabelPreview({ line1, line2, line3 }) {
    const lines = [line1, line2, line3].map(renderLine).filter(Boolean)

    return (
        <PreviewCard>
            {lines.length ? lines : (
                <PreviewEmptyText>Escolha ao menos uma linha para ver como fica.</PreviewEmptyText>
            )}
        </PreviewCard>
    )
}

const PreviewCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: ${colors.neutralBackground};
    border: 1px solid ${colors.neutralDark};
    border-radius: 12px;
    padding: 28px 20px;
    min-height: 150px;
    width: 100%;
`

const PreviewEmptyText = styled.span`
    font-size: ${fonts.sizes.small};
    color: ${colors.nightLight};
    text-align: center;
`

const PreviewText = styled.span`
    font-size: 16px;
    font-weight: 700;
    color: ${colors.nightDark};
    text-align: center;
`

const PreviewBarcode = styled.div`
    width: 70%;
    height: 34px;
    margin-top: 4px;
    background: repeating-linear-gradient(
        90deg,
        ${colors.nightDark} 0px,
        ${colors.nightDark} 2px,
        transparent 2px,
        transparent 5px
    );
`

const PreviewQrCode = styled.div`
    width: 60px;
    height: 60px;
    margin-top: 4px;
    background:
        linear-gradient(${colors.nightDark} 3px, transparent 0) 0 0 / 12px 12px,
        linear-gradient(90deg, ${colors.nightDark} 3px, transparent 0) 0 0 / 12px 12px;
    background-color: ${colors.neutralLight};
    border: 2px solid ${colors.nightDark};
`
